if (!customElements.get('better-together-form')) {
  customElements.define('better-together-form', class BetterTogetherForm extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-add-both-button]');
      this.errorWrapper = this.querySelector('.better-together__error');
      this.spinner = this.querySelector('.loading-overlay__spinner');
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-items');

      if (this.button) {
        this.button.addEventListener('click', this.onAddBoth.bind(this));
      }
    }

    getMainVariantId() {
      const liveInput = document.querySelector('.product-variant-id');
      return (liveInput && liveInput.value) || this.dataset.mainVariantId;
    }

    onAddBoth(evt) {
      evt.preventDefault();
      if (!this.button || this.button.getAttribute('aria-disabled') === 'true') return;

      const mainVariantId = this.getMainVariantId();
      const addonVariantId = this.dataset.addonVariantId;
      if (!mainVariantId || !addonVariantId) return;

      this.hideError();
      this.button.setAttribute('aria-disabled', 'true');
      this.button.classList.add('loading');
      if (this.spinner) this.spinner.classList.remove('hidden');

      const body = {
        items: [
          { id: parseInt(mainVariantId, 10), quantity: 1 },
          { id: parseInt(addonVariantId, 10), quantity: 1 },
        ],
      };

      if (this.cart) {
        body.sections = typeof this.cart.getSectionsToRender === 'function'
          ? this.cart.getSectionsToRender().map((section) => section.id)
          : [];
        body.sections_url = window.location.pathname;
      }

      const config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/json' } };
      config.headers = config.headers || {};
      config.headers['Content-Type'] = 'application/json';
      config.body = JSON.stringify(body);

      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.showError(response.description || response.message || 'Something went wrong, please try again.');
            return;
          }

          if (this.cart && typeof this.cart.renderContents === 'function') {
            this.cart.renderContents(response);
          } else {
            window.location = window.routes.cart_url;
            return;
          }

          document.dispatchEvent(new CustomEvent('afterCartChanged', {
            detail: { source: 'better-together', cartData: response },
          }));
        })
        .catch((error) => {
          console.error(error);
          this.showError('Something went wrong, please try again.');
        })
        .finally(() => {
          if (this.button) {
            this.button.classList.remove('loading');
            this.button.removeAttribute('aria-disabled');
          }
          if (this.spinner) this.spinner.classList.add('hidden');
        });
    }

    showError(message) {
      if (!this.errorWrapper) return;
      this.errorWrapper.textContent = message;
      this.errorWrapper.hidden = false;
    }

    hideError() {
      if (!this.errorWrapper) return;
      this.errorWrapper.hidden = true;
    }
  });
}
